const gqlDoc = `
  query faqs($latest: Int) {
    faqlist(latest: $latest) {
      id
      type
      access
      status
      created
      featured
      title
      body
      category
    }
  }
`

const asyncLoader = ({store, route, rooter}) => {
  if (!route) {
    return Promise.resolve(false)
  }
  let gqlClient = store.getters['getGraphQLClient'](null, gqlDoc)
  const proms = [
    store.dispatch('blob/load', {blobID: `page-blob-top--node-faq-list-header`}),
    store.dispatch('blob/load', {blobID: `page-blob-top--node-faqs-list`}),
    store.dispatch('blob/load', {blobID: `page-blob-bottom--node-faqs-list`})
  ]

  const list = store.getters['list/get']('faqs', 'default', { numitems: store.state.registry.getModuleSetting('faq', 'limit', 15) })

  if (!list || (Array.isArray(list) && list.length <= 0)) {
    proms.push(
      gqlClient.query({opName: 'faqs', variables: { latest: store.state.registry.getModuleSetting('faq', 'limit', 15) }})
        .then(response => {
          if (response && response.data && response.data.faqlist) {
            const mappedList = response.data.faqlist.map(faq => ({ node: { nid: faq.id, ...faq } }))
            store.commit('list/storeListData', { key: 'faqs--default', list: mappedList })
            response.data.faqlist.forEach(faq => {
              if (faq.id) {
                store.dispatch('node/load', { nid: faq.id })
              }
            })
          }
        })
    )
  }
  return Promise.all(proms)
    .then(() => {
      if (store.getters['blob/isHeader']('page-blob-top--node-faq-list-header')) {
        store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
      }
    })
}

const pageMixin = {
  computed: {
    faqs() {
      return this.$store.getters['list/get']('faqs', 'default', { numitems: this.$store.state.registry.getModuleSetting('faq', 'limit', 15) }) || {}
    }
  }
}

export { pageMixin, asyncLoader }
